import { fetchStationFailure, fetchStationSuccess } from "./reducer"
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { STATION_LISTING_API } from "../constants/constants";

export const getAllStation = (setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${STATION_LISTING_API}`, 'GET')
        setLoading(false)
        dispatch(fetchStationSuccess(response.stationList.reverse()));
    } catch (error) {
        dispatch(fetchStationFailure(error.message));
    }
};

